import type { SelectHTMLAttributes } from 'react';
import { Select } from '@/components/ui/form';
import { useOrigenes } from './useOrigenes';

type Props = Omit<SelectHTMLAttributes<HTMLSelectElement>, 'value' | 'onChange'> & {
  valor: string;
  /** Origen que el cliente ya tenía: se sigue mostrando aunque ya no se ofrezca. */
  actual?: string;
  onCambiar: (clave: string) => void;
};

/** Select de «Cómo nos encontró» con las opciones activas. */
export function SelectOrigen({ valor, actual, onCambiar, ...p }: Props) {
  const { activos, etiqueta, cargando } = useOrigenes();
  const conservado = actual && !activos.some((o) => o.clave === actual) ? actual : null;
  return (
    <Select {...p} value={valor} onChange={(e) => onCambiar(e.target.value)} disabled={cargando || p.disabled}>
      {conservado && <option value={conservado}>{`${etiqueta(conservado)} (ya no se ofrece)`}</option>}
      {activos.map((o) => (
        <option key={o.clave} value={o.clave}>
          {o.etiqueta}
        </option>
      ))}
    </Select>
  );
}
